const calculateDv = value =>
  ((11 -
    (value
      .split('')
      .reduce(
        (prev, curr, index) => prev + curr * (1 + value.length - index),
        0
      ) %
      11)) %
    11) %
  10;
const testCpf = value => {
  if (value === value[0].repeat(11)) {
    return false;
  }

  let cpf = value.slice(0, 9);
  cpf += calculateDv(cpf);
  cpf += calculateDv(cpf);

  return cpf === value;
};

export const isCpfValid = value => {
  let cpf = value.replace(/\D+/g, '');

  return 11 === cpf.length && ('00000000000' === cpf || testCpf(cpf));
};

export const isApartamentoValid = value => {
  return !value || 2 < value.replace(/\D+/g, '').length;
};

export const isFuncaoValid = value => {
  return 3 < value.trim().length;
};

export const isTelefoneValid = value => {
  return !value.trim().length || 9 < value.replace(/\D+/g, '').length;
};

export const isDataFuturaValid = value => {
  let today = new Date();
  today.setHours(0, -today.getTimezoneOffset(), 0, 0);

  return new Date(value) >= today;
};



// WEBPACK FOOTER //
// ./src/utils/validation.js